export enum AgreementGroupTipTypeEnum {
  NO_TIP = 'NO_TIP',
  INFO = 'INFO',
  WARN = 'WARN'
}
